import React from 'react'

const Collaboration = () => {
  return (
    <div  style={{marginTop: "200px"}}>Collaboration</div>
  )
}

export default Collaboration